module.exports = "/assets/data/7ad61f1f1ab2a09edf375ba219271a63-RG10.data.json";